/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Txn } from "@src/app/model/txn";
import { User } from "@src/app/model/user";
import { CreditNotePageComponent } from "@src/app/modules/txn/credit-note-page/credit-note-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const CreditNotePageNavRoute = new NavRoute(Txn.TYPE.CREDIT_NOTE.code, ()=>CreditNotePageComponent, 'money_off').setViews((u: User) => {
    return [
        {
            id: 'currentYear',
            name: 'Current Year',
            helpText: 'Credit notes for the current financial year; change the year filter to view a different year',
            filterFields: {
                refNr: null,
                txnCycleId: u.currentTeam.currentPeriod?.cycleId,
            },
        }
    ]
});
